<div class="sidenav hidden-print">
  <button type="button" class="sidemenu-trigger js-sidemenu-trigger" (click)="toggleMenu()">
    <span class="sandwich">
      <span class="sw-topper"></span>
      <span class="sw-bottom"><span class="sw-bottom__inner"></span></span>
      <span class="sw-footer"></span>
    </span>
    <span class="sidemenu-trigger__text">
      {{'Hide menu'|translate }}
    </span>
  </button>
  <ul class="sidemenu">
    <li class="sidemenu__item js-sidemenu-item" [class.active]="isSelected('dispatcher_table')" (click)="select('dispatcher_table')" *ngIf="usersService.IsPermitted(AccessRights.VIEW_CURPOS)">
      <span class="sidemenu__icon">
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path class="cls-1" d="M20 2.125V7.13636H16.3917C16.0825 7.13636 15.7732 7.3409 15.6701 7.54545L14.6392 10.4091L12.9897 2.43182C12.8866 2.22727 12.6804 2.02273 12.3711 2.02273C12.0619 2.02273 11.7526 2.125 11.5464 2.32954L7.93814 7.85226L6.80412 5.39772C6.70103 5.19318 6.49484 5.0909 6.28866 4.98863C6.08247 4.98863 5.77319 4.98863 5.56701 5.0909L2.06185 7.23863H0V2.125C0 1.51136 0.515464 1 1.13402 1H18.7629C19.4845 1 20 1.51136 20 2.125Z" />
          <path class="cls-1" d="M20 8.46595V13.6819C20 14.2955 19.4845 14.8068 18.866 14.8068H1.13402C0.515464 14.9091 0 14.2955 0 13.6819V8.46595H2.37113C2.57732 8.46595 2.68041 8.46595 2.8866 8.36368L5.77319 6.62504L7.21649 9.59095C7.21649 9.79549 7.42268 9.89776 7.73196 10C8.04123 10 8.35051 9.89776 8.4536 9.69322L11.7526 4.57959L13.6082 13.4773C13.7113 13.7841 13.9175 13.9887 14.3299 13.9887C14.6392 13.9887 14.9484 13.7841 15.0515 13.5796L16.9072 8.46595H20V8.46595Z" />
          <path class="cls-1" d="M16.2886 17.7727H13.0928V16.0341H6.90721V17.7727H3.71133C3.40205 17.7727 3.09277 18.0795 3.09277 18.3863C3.09277 18.6931 3.40205 19 3.71133 19H16.1856C16.4948 19 16.8041 18.6931 16.8041 18.3863C16.8041 18.0795 16.5979 17.7727 16.2886 17.7727Z" />
        </svg>
      </span>
      <span class="sidemenu__text">
        {{'Dispatcher'|translate }}
      </span>
    </li>
    <li class="sidemenu__item js-sidemenu-item" [class.active]="isSelected('dispatcher_report')" (click)="select('dispatcher_report')">
      <span class="sidemenu__icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16">
          <path class="cls-1" d="M6,16h4V0H6ZM0,16H4V8H0ZM12,5V16h4V5Z" />
        </svg>
      </span>
      <span class="sidemenu__text">
        {{'Reports'|translate }}
      </span>
    </li>
<!--    <li class="sidemenu__item js-sidemenu-item" [class.active]="isSelected('storage_tank')" (click)="select('storage_tank')">
      <span class="sidemenu__icon">
        <svg width="13" height="18" viewBox="0 0 13 18" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.50023 18C2.91603 18 -5.63095e-08 15.0436 -5.63095e-08 11.41C-5.63095e-08 8.01239 5.34747 1.04946 5.95706 0.266807C6.0883 0.098445 6.2885 0 6.5 0C6.7115 0 6.9117 0.0982112 7.04293 0.266807C7.65276 1.04969 13 8.01239 13 11.41C13.0002 15.0436 10.0844 18 6.50023 18ZM6.50023 1.85128C4.69037 4.28528 1.38386 9.19116 1.38386 11.41C1.38386 14.2701 3.679 16.597 6.50023 16.597C9.32146 16.597 11.6166 14.2703 11.6166 11.41C11.6164 9.19116 8.30986 4.28528 6.50023 1.85128Z" />
          <path d="M6.50028 15.1949C6.1181 15.1949 5.80835 14.8809 5.80835 14.4934C5.80835 14.1059 6.1181 13.7919 6.50028 13.7919C7.79558 13.7919 8.84962 12.724 8.84962 11.4107C8.84962 11.0233 9.15937 10.7092 9.54155 10.7092C9.92349 10.7092 10.2335 11.0233 10.2335 11.4107C10.2332 13.4973 8.55854 15.1949 6.50028 15.1949Z" />
        </svg>
      </span>
      <span class="sidemenu__text">
        {{'Tanks'|translate }}
      </span>
    </li>-->
  </ul>
</div>
